import { useReactFlow, useStore, useViewport } from "@xyflow/react";
import { useCallback } from "react";
import Icon from "~/components/shared/Icon";
import { ControlButton, ControlPanel } from "~/components/Playground/Controls/ControlButton";

const ZoomOutControl = () => {
  const { minZoomReached } = useStore((store) => ({
    minZoomReached: store.transform[2] <= store.minZoom,
  }));

  const { zoomOut } = useReactFlow();
  const handleZoomOut = useCallback(() => zoomOut(), [zoomOut]);

  return (
    <ControlButton onClick={handleZoomOut} label="Zoom out" disabled={minZoomReached}>
      <Icon icon="heroicons/outline/minus" className="h-4 w-5" />
    </ControlButton>
  );
};

const ZoomInControl = () => {
  const { maxZoomReached } = useStore((store) => ({
    maxZoomReached: store.transform[2] >= store.maxZoom,
  }));

  const { zoomIn } = useReactFlow();
  const handleZoomIn = useCallback(() => zoomIn(), [zoomIn]);

  return (
    <ControlButton onClick={handleZoomIn} label="Zoom in" disabled={maxZoomReached}>
      <Icon icon="heroicons/outline/plus" className="h-4 w-5" />
    </ControlButton>
  );
};

const ZoomLevel = () => {
  const { zoom } = useViewport();

  return (
    <span className="inline-block min-w-[2.5rem] text-center text-xs">
      {Math.ceil(zoom * 100)}%
    </span>
  );
};

export function ZoomControls() {
  return (
    <ControlPanel>
      <ZoomOutControl />
      <ZoomLevel />
      <ZoomInControl />
    </ControlPanel>
  );
}
